module.exports = __webpack_public_path__ + "static/media/header-logo.52186843.png";